import { Flex } from '@mantine/core';
import type { FC } from 'react';

import { VerificationBadge } from '../../ui/VerificationBadge/VerificationBadge.tsx';

export interface PasswordRequirement {
  key: string;
  check: (value: string) => boolean;
}

interface PasswordRequirementsListProps {
  requirements: PasswordRequirement[];
  value: string;
}

export const PasswordRequirementsList: FC<PasswordRequirementsListProps> = ({ requirements, value }) => {
  const requirementStatuses = requirements.map((requirement) => ({
    isValid: requirement.check(value),
    key: requirement.key,
  }));

  return (
    <Flex gap="xxxs" wrap="wrap">
      {requirementStatuses.map((status) => (
        <VerificationBadge isCorrect={status.isValid} key={status.key} text={status.key} />
      ))}
    </Flex>
  );
};
